import labels from "../../../utils/labels";
import StandardButton from "../../UI/buttons/StandardButton";
import ColouredRoundWrapper from "../../UI/wrappers/ColouredRoundWrapper";
import statusBarStyles from "../../../styles/statusBars.module.css";
import { ReactComponent as HandIcon } from "../../../assets/icons/hand.svg";
import { ReactComponent as UndoIconWhite } from "../../../assets/icons/undo_white.svg";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import DragAndDropService from "../../../service/dragAndDrop";
import { useState } from "react";

const DragAndDropStatusBar = () => {
  const dispatch = useAppDispatch();
  // Tanja: update spinner to customSpinner
  const { showSpinner } = useAppSelector((state) => state.ganttChartSlice);
  const { activeSessionStatus } = useAppSelector(
    (state) => state.dragAndDropSlice,
  );
  const [enable, setEnable] = useState<boolean>(true);
  const undo = async () => {
    setEnable(false);
    await DragAndDropService.undo(dispatch);
    setEnable(true);
  };

  return (
    <ColouredRoundWrapper
      bgColor="var(--col-interaction-tertiary)"
      height="60px"
      classes={`${statusBarStyles.customPlanInfo} min-w-[261px]`}
    >
      <HandIcon />
      {showSpinner
        ? labels.calculatingTransportation
        : activeSessionStatus?.rulesBroken
          ? `${activeSessionStatus.rulesBroken}  ${labels.violations}`
          : `0 ${labels.violations}`}
      {activeSessionStatus?.canUndo && (
        <StandardButton
          onClick={undo}
          variant="WHITE"
          disable={!enable}
          ariaLabel={labels.undo}
        >
          {labels.undo}
          <UndoIconWhite />
        </StandardButton>
      )}
    </ColouredRoundWrapper>
  );
};

export default DragAndDropStatusBar;
